const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Popups = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domContactPopup: $('.cf7-holder__popup'),
	$domContactInnerPopup: $('.contact-us__popup-inner'),
	$domContactBtnIcon: $('.contact-us__popup-icon'),
	$domContactformHolder: $('.js-cf7-holder'),
	classActive: 'is-active',
	classPreventScroll: 'prevent-scroller',

	/** @description Initialize */
	init: function() {
		this.closeMenuOnOusideContainerClickContact();
		Global.escKey(Popups.closeContactPopup);
		this.closeContactPopupIcon();
	},

	closeContactPopup: function() {
		Popups.$domBody.removeClass(Popups.classPreventScroll);
		Popups.$domContactPopup.removeClass(Popups.classActive);
	},

	closeContactPopupIcon: function() {
		Popups.$domContactBtnIcon.on('click', function() {
			Popups.closeContactPopup();
		});
	},

	closeMenuOnOusideContainerClickContact: function() {
		Global.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domContactPopup.hasClass(Popups.classActive) && !Popups.$domContactInnerPopup.is(e.target) && Popups.$domContactInnerPopup.has(e.target).length === 0 && !Popups.$domContactBtnIcon.is(e.target)) {
				Popups.closeContactPopup();
			}
		});
	},
};

export default Popups;
